// 步骤
// import {addstamp} from '../../util/stamp';
// var params = {
//     user_id: 615
// }
// 接在定义params后
// var sign = addstamp(params)
// delete params.token
// params['sign'] = sign
// console.log(params)

// if(res.data.status_code == 402){
//     that.$router.push('/login')
//   }

// import hmacSHA1 from 'crypto-js/hmac-sha1'
import store from '../store'
import md5 from 'js-md5';
export function addstamp(params) {

    let nowdata = Date.parse(new Date()) / 1000
    let newpar = params
    newpar['timestamp'] = nowdata;
    newpar['token'] = '&k2Fwd72zg3$Qhqw@RH%A3auPNi^*nYj';
    newpar['ip'] = store.state.ip;
    newpar['access_token'] = store.state.access_token;
    newpar = objKeySort(newpar);
    let keys = Object.keys(newpar);
    let value = "";
    for (let i = 0; i < keys.length; i++) {
        let _key = keys[i]
        if (value) {
            value += "&"
        }
        value += _key + '=' + newpar[_key];
    }
    let sign = md5(value)
    return sign
};

export function objKeySort(obj) { //排序的函数
    let newkey = Object.keys(obj).sort();	//先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    let newObj = {}; //创建一个新的对象，用于存放排好序的键值对
    for (let i = 0; i < newkey.length; i++) { //遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]]; //向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj; //返回排好序的新对象
};